//this comes from the deploy-time realmConfig.js, imported by index.html
declare let realmConfig: Environment

export type Realm = 'local' | 'beta' | 'stg1' | 'prd1'
export type CwanEnvironment =
  | 'localDevServer'
  | 'unittest'
  | 'dev'
  | 'staging'
  | 'prod'

export interface Environment {
  realm: Realm
  environment: CwanEnvironment
  production: boolean
  test: boolean
  sidenavBaseUrl: string
  gicMarketplaceWsBaseUrl: string
}

/**
 * This will match the loaded realmConfig.*.js
 * See vite.config.ts to change which realm is used.
 */
export const environment: Environment = { ...realmConfig }
